// extracted by mini-css-extract-plugin
export default {"cell":"TableHeaderCell_cell__KKkca","cell_small":"TableHeaderCell_cell_small__sQHcY"};